import type { Deck } from "."

export const getDeckLevelNumber = ({ deckId }: { deckId: Deck.Id }): number => {
  return {
    ankle_deep: 1,
    waist_deep: 2,
    neck_deep: 3,
  }[deckId]
}
